<template>
	<v-card>
		<v-card-text>
			<v-form v-model="validarFormulario">
				<v-row>
					<v-col>
						<v-text-field
							label="Id Solicitud"
							readonly
							v-model="datosSolicitud.idSolicitud"
						>
						</v-text-field>
					</v-col>
					<v-col>
						<v-text-field
							label="Fecha de Solicitud"
							readonly
							v-model="datosSolicitud.fechaSolicitud"
						>
						</v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field 
							label="Nombre del Paciente" 
							readonly
							v-model="datosSolicitud.paciente"
						>
						</v-text-field>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-combobox 
							label="Terapeuta"
							v-model="terapeuta"
							:items="terapeutaLista"
							item-text="nombre"
							item-value="idTerapeuta"
						>
						</v-combobox>
					</v-col>
				</v-row>
				<v-row>
					<v-col
						cols="12"
						md="6"
					>
						<v-menu
							v-model="menuFecha"
							:close-on-content-click="false"
							:nudge-right="40"
							transition="scale-transition"
							offset-y
							min-width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field 
									v-model="fechaInicio" 
									label="Fecha de Inicio" 
									prepend-icon="mdi-calendar" 
									readonly
									v-bind="attrs" 
									v-on="on"
									:rules="fechaRules"
								></v-text-field>
							</template>
							<v-date-picker 
								v-model="fechaInicio"
								color="teal lighten-1"
								@input="menuFecha = false"
								locale="es-mx"
							>
							</v-date-picker>
						</v-menu>
					</v-col>
					<v-spacer></v-spacer>
					<v-col
						cols="12"
						md="6"
					>
						<v-menu
							ref="menu"
							v-model="menuHora"
							color="teal lighten-1"
							:close-on-content-click="false"
							:nudge-right="40"
							:return-value.sync="hora"
							transition="scale-transition"
							offset-y
							max-width="290px"
							min-width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
									v-model="hora"
									label="Hora de Cita"
									prepend-icon="mdi-clock-time-four-outline"
									readonly
									v-bind="attrs"
									v-on="on"
									:rules="horaRules"
								></v-text-field>
							</template>
							<v-time-picker
								v-if="menuHora"
								color="teal lighten-1"
								v-model="hora"
								full-width
								@click:minute="$refs.menu.save(hora)"
							></v-time-picker>
						</v-menu>
					</v-col>
				</v-row>
				<v-divider></v-divider>
				<v-card-actions>
					<v-row>
						<v-btn 
							color="info"
							@click="generaCitas"
							:disabled="!validarFormulario"
						>Guardar</v-btn>
						<v-spacer></v-spacer>
						<v-btn 
							color="success"
							@click="cancelar"
						>Cancelar</v-btn>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import ServiciosApi from '@/services/ServiciosApi'
export default {
	name: 'Citas',
	props: {
		datosSolicitud: {
			type: Object,
			required: true
		},
	},
	data() {
		return {
			terapeutaLista: [],
			terapeuta: '',
			fechaInicio: '',
			menuFecha: false,
			menuHora: false,
			hora: '',
			validarFormulario: true,
			fechaRules: [
				value => !!value || "Debe especificar una fecha"
			],
			horaRules: [
				value => !!value || "Debe especificar la hora"
			]
		}
	},
	mounted: function() {
		console.log("datosSolicitud en mounted:", this.datosSolicitud)
		ServiciosApi.catalogosTodos(4)
			.then(response => {
				this.respuesta = response.data
				this.terapeutaLista = this.respuesta.datos.terapeuta
			})
			.catch(error => {
				console.log("Hubieron errores en citas mounted", error.response)
			})
	},
	methods: {
		cancelar() {
			const estatus = { 
				idSolicitud : 0, 
				mensaje: 'Solicitud Cancelada',
			}
			console.log("Citas.vue, idSolicitud: ", estatus.idSolicitud)
			this.fechaInicio = ''
			this.hora = ''
			this.$emit('estatus-solicitud', estatus)
		},
		generaCitas() {
			const datosParaCitas = {
				idSolicitud: this.datosSolicitud.idSolicitud,
				fechaInicio: this.fechaInicio,
				hora: this.hora,
				idTerapeuta: this.terapeuta.idTerapeuta,
			}
			ServiciosApi.agendaCitas(datosParaCitas)
				.then(response => {
					this.respuesta = response.data
					if(this.respuesta.status === 'ok'){
						const estatus = {
							idSolicitud: 0,
							mensaje: this.respuesta.mensaje, 
						}
						this.$emit('estatus-solicitud', estatus)
					} else {
						console.log("Informar del error que se generó")
            const errorGenerado = {
              idSolicitud: this.datosSolicitud.idSolicitud,
              mensaje: this.respuesta.mensaje
            }
            this.$emit('estatus-solicitud', errorGenerado)
					}
				})
				.catch(error =>{
					console.log("Hubieron errores en citas.vue", error.response)
				})
		}
	}
}
</script>
